// extracted by mini-css-extract-plugin
module.exports = {"fixed-body":"useBodyScrollLock_fixed-body__A6g2O","body-size":"useBodyScrollLock_body-size__jqphR"};